// src/lib/buildingFacts.js — the pure rules behind BuildingFacts.jsx (year built · lift · parking ·
// heating). A plain module so node --test can import it; the component is JSX and cannot be.
// Heating types, in the order agents meet them. `heat_unspecified` ("has heating, type unknown")
// is deliberately not offered: an agent on the phone either names the type or leaves it blank.
export const HEATING_CODES = ['heat_central', 'heat_gas', 'heat_electric', 'heat_italian', 'heat_floor', 'heat_none']

// The three-state answers that CHANGED since the prefill, as chip_states. Nothing changed → undefined,
// so an untouched form sends nothing (the same "only what the agent changed" rule as facts).
export function changedChipStates(base, cur) {
  const out = {}
  for (const k of ['elevator', 'parking']) {
    if (cur[k] !== base[k] && (cur[k] === 'true' || cur[k] === 'false')) out[k] = cur[k] === 'true'
  }
  for (const code of cur.heat || []) if (!(base.heat || []).includes(code)) out[code] = true
  return Object.keys(out).length ? out : undefined
}


// A plausible building year: a whole year from 1850 through current year + 6. ONE definition for every
// screen that asks (the add-property form, the valuation tab), matching core_ingest's rejection and
// answer_axis_v1's guard (core 1231). Blank is "not stated", which is always valid.
export const YEAR_BUILT_MIN = 1850
export const yearBuiltMax = (now = new Date()) => now.getFullYear() + 6
export function yearBuiltValid(v, now = new Date()) {
  if (v === '' || v == null) return true
  const n = +v
  return Number.isInteger(n) && n >= YEAR_BUILT_MIN && n <= yearBuiltMax(now)
}
